// src/core/composables/useEmailApi.ts
import type { EmailMessage } from "@/models";
import { emailService } from "@/core/services/email.service";
import { createApiComposable } from "@/core/composables/createApiComposable";

export function useEmailApi() {
  const api = createApiComposable({
    defaultErrorMessage: "Email request failed",
  });

  const sendMail = async (message: EmailMessage) => {
    await api.runVoid(() => emailService.sendMail(message), "Failed to send email");
  };

  const logMail = async (message: EmailMessage, status: string) => {
    await api.runVoid(() => emailService.logMail(message, status), "Failed to log email");
  };

  return {
    loading: api.loading,
    error: api.error,
    clearError: api.clearError,
    sendMail,
    logMail,
  };
}
